import {
  Component, OnInit, Renderer2, HostListener, Inject, ChangeDetectorRef, AfterViewChecked
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FlowInformationService } from './flow-information.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { Flow } from '../../models/Flow';
import { Utilities } from '../../utilities';
import { environment } from '../../../../environments/environment';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopupModalComponent } from '../popup-modal/popup-modal.component';
import { Content } from '../../models/content';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import html2canvas from 'html2canvas';
import { Control } from '../../models/model-year';
import { VideoPlayerDialogComponent } from '../video-player-dialog/video-player-dialog.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LoaderService } from '../../loader/loader.service';
import { HeadUnitPayload } from '../../models/headunit-payload';
import { PhoneManufacturerService } from '../phone-manufacturer/phone-manufacturer.service';
import _ from 'lodash';
import { MsalService } from '@azure/msal-angular';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-flow-information',
  templateUrl: './flow-information.component.html',
  styleUrls: ['./flow-information.component.scss']
})

export class FlowInformationComponent implements OnInit {
  public appName = environment.applicationName;
  public baseUrl = environment.baseURL;
  public backArrowURL = `${environment.baseURL}content/${environment.applicationName}/common/back-arrow.svg`;
  public nextArrowURL = `${environment.baseURL}content/${environment.applicationName}/common/next-arrow.svg`;
  private appBase = TCCPConstantValues[this.appName];
  public flowData: Flow;
  public flowArray: string[] = [];
  public flowId = '';
  public carouselSlides: Array<string> = [];
  public initialFlowId: string;
  public contentWithoutTag = '';
  public showMoreText = false;
  public windowWidth: number;
  public issueNotResolved: boolean;
  public contents: Content[];
  public windowHeight: number = window.innerHeight - 500;
  public theme: string = environment.applicationName;
  public isPreview = false;
  public vehicleFeatures: Control[] = [];
  public previewFlow = false;
  public reviewCommentsInfo = {};
  public previewFromPublish = false;
  public enableReview = false;
  public showFeedback = false;
  public progressBarInfo = null;
  public learnmoreLink = { content: '', text: 0 };
  public showProgressBar = true;
  public controlMap;
  public huConfigList: number[] = [];
  public tagSent = false;
  public level = 0;
  public vehicleGen = '';
  public showVinInput: boolean = false; // Flag to control VIN input visibility
  public vinError: boolean = false; // Flag for VIN error state
  public vinOptions: string[] = []; // Array for autocomplete options
  public searchForm: FormGroup; // Reactive form for VIN input

  constructor(
    private phoneManufacturerService: PhoneManufacturerService,
    private loaderService: LoaderService,
    private route: ActivatedRoute, private router: Router,
    private flowService: FlowInformationService, private breadcrumbService: BreadcrumbService,
    public commonService: TCCPCommonService, private renderer: Renderer2,
    public storageService: TCCPLocalStorageService,
    public authService: MsalService,
    private dialog: MatDialog, private cdRef: ChangeDetectorRef, private sanitizer: DomSanitizer) {
    this.commonService.hideModelYearSection.emit(true);
    this.commonService.hideBanner.emit(true);
  }

  ngOnInit() {
    this.commonService.hideBreadrumb.emit(false);
    this.controlMap = new Map<number, string>();
    const gModel = this.storageService.getVehicleModelName();
    if (this.storageService.getFeature()) {
      if (this.storageService.getFeature().name === 'bluetooth® pairing' && !gModel.toLowerCase().includes('subaru')) {
        this.makeCallToApi();
        this.storageService.setShowBluetoothComp(true);
      }
    } else {
      this.storageService.setShowBluetoothComp(true);
    }
    if (!this.vehicleGen) {
      this.getVehicleGen();
    }

    this.commonService.hideModelYearSection.emit(true);
    this.commonService.hideBanner.emit(true);
    const progressBarStatus = this.storageService.getProgressBar();
    this.showProgressBar = progressBarStatus === undefined ? true : !progressBarStatus ? true : false;
    this.progressBarInfo = { show: false };
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.commonService.enableFeedback = true;
    this.windowHeight = this.windowHeight > 500 ? this.windowHeight : 500;
    this.windowWidth = window.innerWidth;
    this.commonService.changeLayoutStyle.emit(false);
    this.issueNotResolved = false;
    this.isPreview = this.storageService.GetPreview();
    this.previewFromPublish = this.storageService.getPreviewFromPublish();
    this.enableReview = this.storageService.getReview();
    this.commonService.setGTagPageDetails('Feature', `${this.appName}/feature`, window.location.href);
    this.showFeedback = this.storageService.getVehicleModel().name && this.storageService.getVehicleYear().name &&
      this.storageService.getFeature().name && (this.authService.instance.getActiveAccount() != null) ? true : false;

    this.route.params.subscribe(params => {
      const idAttr = 'id';
      if (params) {
        if (params[idAttr]) {
          this.flowId = params[idAttr].toString();
        }
        this.flowArray = this.storageService.getFlow();
        this.initialFlowId = this.flowArray.length > 0 ? this.flowArray[this.flowArray.length - 1] : this.flowId;
        this.getFlow(this.initialFlowId, '');
      }
    });

    this.commonService.backToDashboardFlow.subscribe((data) => {
      this.backToDashboard();
    });

    this.commonService.getDoneFlow.subscribe((data) => {
      this.getDoneFlow();
    });

    this.commonService.clearFlowPage.subscribe((data) => {
      if (data === 'FEATURE') {
        const name = this.storageService.getFeature().name;
        const link = this.storageService.getFeature().link;
        this.getFlow(this.storageService.getSelectedFeatureId());
        this.flowArray.splice(1, this.flowArray.length - 1);
        this.storageService.setFlow(this.flowArray);
        this.breadcrumbService.clearBreadcrumb.emit(true);
        this.storageService.setFeature(name, link);
        this.router.navigateByUrl(link);
        this.breadcrumbService.showBreadcrumb.emit(true);
      }
    });

    setTimeout(() => {
      const videoBlocks = Array.from(document.querySelectorAll('.youtube-video-block')) as HTMLElement[];
      videoBlocks.forEach(videoBlock => {
        videoBlock.style.cursor = 'pointer';
        videoBlock.addEventListener('click', () => {
          const video = videoBlock as HTMLElement;
          this.openYoutubeVideoDialog(video.getAttribute('url'));
        });
      });
    }, 500);
    this.commonService.hideBanner.emit(true);
  }

  fetchVehicleDetails(vin: string) {
    // Implement the logic to fetch vehicle details using the VIN
    this.commonService.getVehicleInfo(this.storageService.getVehicleVin().name).subscribe(vinData => {
      this.commonService.vinDetails = vinData;
    
      if (vinData && vinData.summary) {
        this.vinError = false;
      } else {
        this.vinError = true; // Set error if no data found
      }
    }, error => {
      this.vinError = true; // Set error if API call fails
    });
  }
  onVinKeyup(vin: string) {
    const trimmedVin = vin.trim();

    if (trimmedVin.length === 17) {
      this.vinError = false;
      this.fetchVehicleDetails(trimmedVin);
    } else {
      this.vinError = true;
    }
  }
  async getVehicleGen() {
    this.commonService.getmodelName().subscribe(data => {
      data.forEach(element => {
        if (element.model === this.storageService.getVehicleModel().name) {
          const gen = element.years.find(resultData => {
            return `${resultData.year} ` === `${this.storageService.getVehicleYear().name} `;
          });
          this.storageService.setVehicleGeneration(gen.generation, this.router.url);
          this.vehicleGen = gen.generation;
          this.storageService.setVehicleModelName(element.model);
          this.setGtag();
        }
      });
    });
  }

  setGtag() {
    if (!this.storageService.getFromDashboard()) {
      const gModel = this.storageService.getVehicleModelName();
      const gYear = this.storageService.getVehicleYear().name;
      const featureName = this.storageService.getFeature().name;
      if (featureName !== '' && this.vehicleGen.indexOf('21MM') !== -1) {
        this.commonService.setGTagEventDetails('Feature', '21MM ' + featureName, 'Features Clicked');
        this.commonService.setGTagEventDetails('ModelYearFeature', `21MM ${featureName} | m=${gModel} y=${gYear}`,
          'ModelYearFeatures Clicked');
      } else if (featureName !== '') {
        this.commonService.setGTagEventDetails('Feature', '' + featureName, 'Features Clicked');
        this.commonService.setGTagEventDetails('ModelYearFeature', `${featureName} | m=${gModel} y=${gYear}`,
          'ModelYearFeatures Clicked');
      }
    }
  }

  makeCallToApi() {
    this.loaderService.show();
    const requestData = this.getPayload(this.storageService.getVehicleVin().name);
    this.phoneManufacturerService.getHUConfigList(requestData).subscribe(resultData => {
      if (resultData.data.headUnits) {
        resultData.data.headUnits.forEach((data, index) => {
          this.huConfigList.push(data.huConfigId);
        });
        this.phoneManufacturerService.getManufaturerList(this.huConfigList)
          .subscribe(data => {
            if (data) {
              const btCompatabilityFlag = _.get(data, 'type') === 'Data Exception';
              this.storageService.setShowBluetoothComp(btCompatabilityFlag);
            }
            this.loaderService.hide();
          });
      } else {
        this.storageService.setShowBluetoothComp(true);
      }
    });
  }

  sendGtagFlow(flowArray, answer?: string) {
    if (this.flowArray && this.flowArray.length > 1) {
      this.commonService.setGTagEventDetails(`Helpful Question answer = ${answer} `,
        `generation = ${this.vehicleGen} þ parent = ${this.storageService.feature.name} þ controlName = ${this.controlMap.get(flowArray[1])} þ answer = ${answer} `,
        `Helpful Question`);
    }
  }

  public getFlowDetails(parentControlName: string, controlName: string, targetId: number) {
    if (this.tagSent === false) {
      if (controlName !== '') {
        const category = this.storageService.vehicleGeneration !== undefined ?
          `generation = ${this.storageService.vehicleGeneration.name} þ parent = ${parentControlName} þ controlName = ${controlName} ` :
          `generation = null þ parent = ${parentControlName} þ controlName = ${controlName} `;
        this.commonService.setGTagEventDetails(`Sub Feature ${parentControlName} `, category, 'Sub Features');
        this.commonService.setGTagPageDetails('Feature Detail', `${this.appName}/feature/${controlName}/${targetId}`, window.location.href);
      }
    }
    this.tagSent = true;
  }

  getPayload(vin) {
    let requestData: HeadUnitPayload;
    if (_.isNil(vin) || _.isEmpty(vin)) {
      requestData = {
        headUnitConfigArray: this.huConfigList,
        modelName: this.storageService.getVehicleModelName(),
        mpc: '',
        mpcOption: false,
        year: this.storageService.getVehicleYear().name
      };
    } else {
      requestData = {
        headUnitConfigArray: [],
        modelName: this.storageService.getVehicleModelName(),
        modelCode: this.storageService.getModelCode(),
        mpc: this.storageService.getMPCCode(),
        mpcOption: true,
        year: this.storageService.getVehicleYear().name
      };
    }
    return requestData;
  }


  openYoutubeVideoDialog(videoURL) {
    /* Add youtube vide related changes here */
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = videoURL.match(regExp);
    const videoId = (match && match[7].length === 11) ? match[7] : false;
    this.dialog.open(VideoPlayerDialogComponent, { data: { videoUrl: videoId, name: 'Dummy Name' }, panelClass: 'icon-outside' });
  }

  public checkControlType(controlsList) {
    return this.commonService.checkStepControlType(controlsList);
  }

  public getFlow(flowId: string, action?: string) {
    this.progressBarInfo = { show: false };
    if (this.showProgressBar) {
      let selectedStep = this.storageService.getSelectedStep();
      if (Object.keys(this.commonService.stepDetailArray).length > 0) {
        for (const a in this.commonService.stepDetailArray) {
          if (a === flowId) {
            selectedStep = this.commonService.stepDetailArray[a];
          }
        }
      }

      if (selectedStep) {
        this.progressBarInfo.percentage = selectedStep;
        if (action !== '' && action !== 'back') {
          if (this.progressBarInfo && this.progressBarInfo.totalStepCount === 0) {
            this.progressBarInfo.show = false;
          } else {
            this.progressBarInfo.show = this.progressBarInfo && !this.progressBarInfo.isNested &&
              this.progressBarInfo.stepCount > 1 ? true : this.progressBarInfo && this.progressBarInfo.isNested &&
                this.progressBarInfo.stepCount > 0 ? true : false;
            this.progressBarInfo.show = this.progressBarInfo && this.progressBarInfo.isNested &&
              this.progressBarInfo.stepCount === 1 && this.progressBarInfo.stepInfo[0].targetId &&
              this.progressBarInfo.stepInfo[0].targetId.length > 1 ? true : this.progressBarInfo.show;
            const a = this.progressBarInfo && this.progressBarInfo.stepInfo &&
              this.progressBarInfo.stepInfo.findIndex(x => x.featureId === flowId);
            if (a > -1) {
              let progressBarTracker = this.storageService.getProgressBarTracker();
              progressBarTracker = progressBarTracker === undefined ? [] : progressBarTracker;
              const currentStepTracker = a + 1;
              if (selectedStep.percentage !== undefined) {
                if ((a + 1) === this.progressBarInfo.totalStepCount) {
                  this.progressBarInfo.show = true;
                  this.progressBarInfo.percentage = this.progressBarInfo.isNested ? 50 : 100;
                } else {
                  this.setProgressBarTracking(flowId, selectedStep, currentStepTracker);
                }
              } else {
                this.setProgressBarTracking(flowId, selectedStep, currentStepTracker);
              }
              progressBarTracker[this.progressBarInfo.stepInfo[a].featureId] = this.progressBarInfo.percentage;
              this.storageService.setProgressBarTracker(progressBarTracker);
            }
          }
        }
        this.storageService.setSelectedStep(this.progressBarInfo);
      } else {
        this.progressBarInfo = { show: false };
      }
    }

    this.flowArray = Utilities.getUniqueList(this.flowArray);
    if (action !== '' && action === 'back') {
      this.tagSent = false;
      this.flowArray.splice(-1, 1);
      if (this.showProgressBar) {
        if (this.flowData !== undefined && this.flowData) {
          let progressBarTracker = this.storageService.getProgressBarTracker();
          progressBarTracker = progressBarTracker === undefined ? [] : progressBarTracker;
          this.progressBarInfo = this.progressBarInfo.percentage < progressBarTracker[this.flowArray[this.flowArray.length - 1]] ? null :
            this.progressBarInfo.percentage = progressBarTracker[this.flowArray[this.flowArray.length - 1]];
          this.storageService.setProgressBarTracker(progressBarTracker);
          this.storageService.setSelectedStep(this.progressBarInfo);
        }
      }
      if (this.flowArray && this.flowArray.length === 0) {
        this.vehicleFeatures = this.storageService.getVehicleFeatures();
        if (this.vehicleFeatures && this.vehicleFeatures.length > 0) {
          this.previewFlow = true;
          this.enableReview = false;
        } else {
          this.storageService.setPreviewFromPublish(false);
          this.previewFromPublish = false;
          this.router.navigate([`${this.appName}/dashboard`]);
          flowId = '';
          this.previewFlow = false;
        }
      } else {
        flowId = this.flowArray[this.flowArray.length - 1];
      }
    }

    if (action !== '' && action === 'done') {
      this.getDoneFlow();
    }

    if (flowId && flowId !== '') {
      this.makeFlowRequest(flowId);
      // Get rid of Unnwanted calls to Api
      // Causing issue with redirection
      /* const selectedStepIssueId = this.storageService.getSelectedStepIssueId();
      if (selectedStepIssueId !== flowId) {
        this.makeFlowRequest(flowId);
      } else {
        const featureIDFromBreadcrumb = this.storageService.getSelectedFeatureId();
        if (selectedStepIssueId === featureIDFromBreadcrumb) {
          this.makeFlowRequest(featureIDFromBreadcrumb);
        }
      } */
    }
  }

  makeFlowRequest(flowId) {
    this.storageService.setSelectedStepIssueId(flowId);
    if (this.controlMap.size > 0) {
      if (this.controlMap.has(flowId)) {
        this.storageService.setSelectedStepControlName(this.controlMap.get(flowId));
        this.storageService.setSubTopic(this.storageService.getSelectedStepControlName().toString().toLowerCase(), this.router.url.replace(this.flowId, flowId));
      }
      this.getFlowDetails(this.storageService.getFeature().name, this.storageService.getSelectedStepControlName(), flowId);
    }
    this.flowService.getFlow(flowId).subscribe(data => {
      if (data) {
        if (!this.isPreview) {
          if (!this.previewFromPublish) {
            this.commonService.setBackground(this.renderer, this.appName);
          }
        }

        if (data && data.Item && data.Item.controls && data.Item.controls.length > 0) {
          this.progressBarInfo = null;
        }
        this.reviewCommentsInfo['source'] = environment.applicationName;
        this.reviewCommentsInfo['issueId'] = data.Item.issueId;
        let reviewCommentLength = 0;
        reviewCommentLength = data.Item.reviewComments && data.Item.reviewComments !== undefined ? data.Item.reviewComments.length : 0;
        this.commonService.reviewCommmentLength.emit(reviewCommentLength);
        if (this.flowId) {
          this.router.navigateByUrl(this.router.url.replace(this.flowId, flowId));
        }
        this.flowData = data.Item;
        if (!this.storageService.getShowBluetoothComp()) {
          this.flowData.phoneCompatibilty = null;
        }
        this.flowData.controls.forEach(control => {
          if (control) {
            if (!this.flowData.isControlAsButton) {
              control.controlType = 'tile';
            }
            if (this.level === 0) {
              this.controlMap.set(control.targetId, control.controlName);
            }
            control['type'] = this.flowData.type;
            this.tagSent = false;
          }
        });
        this.level++;

        this.flowData.controls = this.checkControlType(this.flowData.controls);
        if (this.flowData.documents) {
          this.getAllContents();
        }

        const regex = /(<([^>]+)>)/ig;
        this.contentWithoutTag = this.flowData.informationOrQuestion ? this.flowData.informationOrQuestion.replace(regex, '') : '';
        this.learnmoreLink = { content: this.flowData.notes, text: this.contentWithoutTag.length };
        this.flowArray.push(this.flowData.issueId);
        this.storageService.setFlow(this.flowArray);
        this.carouselSlides = [...this.flowData.imagesOrVideos ? this.flowData.imagesOrVideos : []];

        setTimeout(() => {
          html2canvas(document.querySelector('#' + this.appName + '-app')).then(canvas => {
            this.flowService.screenshotInfo = canvas.toDataURL('image/png');
          });

          const disclaimers = Array.from(document.querySelectorAll('.disclaimer-block'));
          disclaimers.forEach(disclaimer => {
            disclaimer.addEventListener('click', () => {
              const dis = disclaimer as HTMLElement;
              this.openDisclaimerDialog(dis.innerText);
            });
          });
        }, 500);
        if (this.showProgressBar) {
          if (this.flowData && this.flowData.controls && this.flowData.controls.length > 0) {
            for (let i = 0; i < this.flowData.controls.length; i++) {
              this.flowService.getFlowCount(this.flowData.controls[i].targetId.toString()).subscribe(response => {
                if (response) {
                  this.storageService.setAfterControlStep(false);
                  response.totalStepCount = response.stepCount;
                  response.show = false;
                  if (response.stepCount > 0) {
                    response.show = true;
                    response.calculativePercentage = response.isNested ? 50 / response.stepCount : 100 / response.stepCount;
                    if (response.isNested && response.stepInfo && response.stepInfo.length > 1) {
                      response.stepInfo.forEach(x => {
                        if (x.targetId && x.targetId.length > 0) {
                          this.storageService.setNestedStep(response);
                        }
                      });
                    }
                  }
                  if (this.flowData && this.flowData.controls && this.flowData.controls[i] && this.flowData.controls[i] !== undefined) {
                    this.commonService.stepDetailArray[this.flowData.controls[i].targetId.toString()] = response;
                  }
                }
              });
            }
          }
        }
      }
    });
  }

  setProgressBarTracking(flowId, selectedStep, currentStepTracker) {
    const controlInfo = this.storageService.getAfterControlStep();
    const selectedNestedStep = this.storageService.getNestedStep();
    if (selectedNestedStep) {
      let lastStep;
      if (selectedStep.percentage !== undefined) {
        selectedNestedStep.stepInfo[selectedNestedStep.stepInfo.length - 1].targetId.findIndex(z => {
          if (z === flowId) {
            lastStep = selectedNestedStep.stepInfo[selectedNestedStep.stepInfo.length - 1].targetId;
            this.storageService.setAfterControlStep({
              afterControlStep: true,
              percentage: 50 + ((selectedStep.calculativePercentage / 2) * currentStepTracker)
            });
          }
        });
      } else {
        selectedNestedStep.stepInfo.forEach(y => {
          y.targetId.findIndex(z => {
            if (z === flowId) {
              lastStep = y;
              this.storageService.setAfterControlStep({
                afterControlStep: true,
                percentage: 50 + ((selectedStep.calculativePercentage / 2) * currentStepTracker)
              });
            }
          });
        });
      }
      if (controlInfo && controlInfo.afterControlStep) {
        this.progressBarInfo.percentage = 50 + ((selectedStep.calculativePercentage / 2) * currentStepTracker);
      } else if (lastStep) {
        this.progressBarInfo.percentage = 50 + ((selectedStep.calculativePercentage / 2) * currentStepTracker);
      } else {
        this.progressBarInfo.percentage = currentStepTracker > 1 ?
          (selectedStep.calculativePercentage * currentStepTracker) : selectedStep.calculativePercentage;
      }
    } else {
      this.progressBarInfo.percentage = currentStepTracker > 1 ?
        (selectedStep.calculativePercentage * currentStepTracker) : selectedStep.calculativePercentage;
    }
  }

  public getAllContents() {
    this.flowService.getAllDocuments().subscribe(data => {
      if (data) {
        this.contents = data;
      }
    });
  }

  public getDoneFlow() {
    this.enableReview = true;
    this.storageService.setReview(true);
    this.storageService.setVehicleModel('', null);
    this.storageService.setVehicleYear(null, null);
    const path = this.storageService.getFeatureType() === 'internal' ? `/${environment.applicationName}/home/internal`
      : `/${environment.applicationName}/home`;
    this.router.navigate([path]);
    this.commonService.selectedFeature.name = '';
    this.commonService.selectedFeature.link = '';
    this.storageService.setFeature('', null);
    this.breadcrumbService.showBreadcrumb.emit(true);
    this.commonService.hideBreadrumb.emit(true);
    this.commonService.hideModelYearSection.emit(false);
  }

  public backToDashboard() {
    if (this.flowData.targetId == null && this.flowData.isLastStep) {
      this.vehicleFeatures = this.storageService.getVehicleFeatures();
      if (this.vehicleFeatures && this.vehicleFeatures.length > 0) {
        this.previewFlow = true;
      } else {
        this.enableReview = false;
        this.router.navigate([`${this.appName}/dashboard`]);
      }
    }
  }

  public goToDashBoard() {
    this.router.navigate([`${this.appName}/dashboard`]);
  }

  openPopupDialog(): void {
    const dialogRef = this.dialog.open(PopupModalComponent, {
      width: '450px',
      height: '220px',
      data: 'Thank you for your feedback!',
      position: { top: '100px' },
      id: this.appName + '_last_step_popup'
    });
  }

  yesButtonClicked(): void {
    this.sendGtagFlow(this.flowArray, 'YES');
    this.openPopupDialog();
  }

  noButtonClicked(): void {
    this.sendGtagFlow(this.flowArray, 'NO');
    this.openPopupDialog();
  }

  public getCompatible(path: string) {
    this.storageService.setBluetoothIssueId(this.flowData.issueId);
    this.router.navigateByUrl(`${this.appName}/bluetooth-compatability`);
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.windowWidth = window.innerWidth;
  }

  @HostListener('window:keydown.ArrowRight', ['$event'])
  arrowRightClickHandler(event: KeyboardEvent) {
    if (event.key === 'arrow right') {
      this.getFlow(this.flowData.targetId.toString(), 'next');
    }
  }

  @HostListener('window:keydown.ArrowLeft', ['$event'])
  arrowLeftClickHandler(event: KeyboardEvent) {
    if (event.key === 'arrow left') {
      const path = this.flowData.targetId ? this.flowData.targetId.toString() : '';
      this.getFlow(path, 'back');
    }
  }

  ngAfterViewChecked() {
    this.breadcrumbService.showBreadcrumb.emit(true);
    this.commonService.changeLayoutStyle.emit(false);
    this.cdRef.detectChanges();
  }

  openDisclaimerDialog(id) {
    this.flowService.getDisclaimer(id).subscribe(data => {
      const disclaimer = data[0].disclaimer.disclaimerId + '. ' + data[0].disclaimer.disclaimerMessage;
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '900px',
        data: { type: 'disclaimer', title: data[0].disclaimer.disclaimerTitle, message: disclaimer },
        position: { top: '150px' },
        id: this.appName + '_disclaimer_popup'
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    });
  }

  issueUnresolved() {
    this.issueNotResolved = true;
  }

  openTroubleshootingPopup(troubleshoot) {
    const troubleShootingText = troubleshoot && troubleshoot !== undefined && troubleshoot.troubleshootingSteps ?
      troubleshoot.troubleshootingSteps : '';
    const dialogRef = this.dialog.open(TroubleshootingDialogComponent, {
      width: this.windowWidth && this.windowWidth > 768 ? this.windowWidth > 1800 ? '65vw' : '75vw' : '85vw',
      data: { title: 'Troubleshooting Steps', message: troubleShootingText },
      position: { top: '150px' },
      id: this.appName + '-troubleshooting-popup'
    });
  }
}

@Component({
  selector: 'app-troubleshooting-dialog-component',
  templateUrl: './troubleshooting-dialog.html',
  styleUrls: ['./flow-information.component.scss']
})

export class TroubleshootingDialogComponent implements OnInit {
  public appName: string = environment.applicationName;
  public troubleshootingSteps = this.data;
  constructor(
    public dialogRef: MatDialogRef<FlowInformationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private flowService: FlowInformationService, private dialog: MatDialog) {
  }

  ngOnInit() {
    setTimeout(() => {
      const disclaimers = Array.from(document.querySelectorAll('.disclaimer-block'));
      disclaimers.forEach(disclaimer => {
        disclaimer.addEventListener('click', () => {
          const dis = disclaimer as HTMLElement;
          this.openDisclaimerDialog(dis.innerText);
        });
      });
    }, 500);
  }

  openDisclaimerDialog(id) {
    this.flowService.getDisclaimer(id).subscribe(data => {
      const disclaimer = data[0].disclaimer.disclaimerId + '. ' + data[0].disclaimer.disclaimerMessage;
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '900px',
        data: { type: 'disclaimer', title: data[0].disclaimer.disclaimerTitle, message: disclaimer },
        position: { top: '150px' },
        id: this.appName + '_disclaimer_popup'
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}

